import ValidService from '../../../service/ValidService';
let model = {};

// dữ liệu form
model.dataForm = {
    "name": // optional Tên công ty
    {
        "name_vi": undefined, // required Tên công ty tiếng việt
        "name_en": undefined, // optional Tên công ty tiếng anh
        "abbreviation_name": undefined, // required, minLength: 3, maxLength: 5 Tên viết tắt
    },
    "representative": // optional Người đại diện
    {
        "name": undefined, // optional Tên người đại diện
        "gender": undefined, // optional, enum(MALE, FEMALE, OTHER) - Giới tính nam, nữ, khác
        "phone_number": undefined, // optional Điện thoại cố định
        "mobile_phone": undefined, // required, pattern: //^0\d{9}$// pattern: /^0\d{9}$/ Điện thoại
        "email": undefined, // required Email
        "address": // optional Địa chỉ người đại diện
        {
            "province_id": undefined, // optional Mã tỉnh/TP
            "province_name": undefined, // optional Tên tỉnh/TP
            "district_id": undefined, // optional Mã quận/huyện
            "district_name": undefined, // optional Tên quận/huyện
            "commune_id": undefined, // optional Mã xã
            "commune_name": undefined, // optional Tên xã
            "address": undefined, // optional Địa chỉ đầy đủ
        },
        "identity_card": undefined, // optional Số CMT
        "identity_card_img_before_id": undefined, // optional Ảnh của CMT mặt trước
        "identity_card_img_after_id": undefined, // optional Ảnh của CMT mặt sau
        "position_id": undefined, // optional, ref: position - Chức vụ
    },
    "contact": // optional Người liên hệ
    {
        "name": undefined, // optional Tên người liên hệ
        "phone_number": undefined, // optional Điện thoại cố định
        "mobile_phone": undefined, // required, pattern: //^0\d{9}$// pattern: /^0\d{9}$/ Điện thoại
        "address": // optional Địa chỉ người đại diện
        {
            "province_id": undefined, // optional Mã tỉnh/TP
            "province_name": undefined, // optional Tên tỉnh/TP
            "district_id": undefined, // optional Mã quận/huyện
            "district_name": undefined, // optional Tên quận/huyện
            "commune_id": undefined, // optional Mã xã
            "commune_name": undefined, // optional Tên xã
            "address": undefined, // optional Địa chỉ đầy đủ
        },
        "identity_card": undefined, // optional Số CMT
        "identity_card_img_before_id": undefined, // optional Ảnh của CMT mặt trước
        "identity_card_img_after_id": undefined, // optional Ảnh của CMT mặt sau
    },
    "address": // required Trụ sở chính
    {
        "province_id": undefined, // optional Mã tỉnh/TP
        "province_name": undefined, // optional Tên tỉnh/TP
        "district_id": undefined, // optional Mã quận/huyện
        "district_name": undefined, // optional Tên quận/huyện
        "commune_id": undefined, // optional Mã xã
        "commune_name": undefined, // optional Tên xã
        "address": undefined, // optional Địa chỉ đầy đủ
    },
    "phone_number": // required Điện thoại công ty
    {
        "phone_number": undefined, // optional Điện thoại cố định
        "mobile_phone": undefined, // optional, pattern: //^0\d{9}$// Điện thoại di động
    },
    "fax": undefined, // optional - Số fax
    "business_registration": // optional - Đăng ký kinh doanh
    {
      "number": undefined, // optional - Số đăng ký kinh doanh
      "issue_date": undefined, // optional - Ngày cấp
      "issue_by": undefined, // optional - Nơi cấp
    },
    "tax_number": undefined, // optional - Mã số thuế
    "disabled": undefined, // required Đã bị khóa chưa
    "logo_id": undefined,
    "bank_account": // optional - Thông tin tài khoản công ty
    {
      "number": undefined, // optional - Số tài khoản
      "bank_name": undefined, // optional - Tên ngân hàng
      "bank_branch_name": undefined, // optional - Tên chi nhánh
    },
    "organization_type": undefined, // optional - Loại tổ chức: COMPANY (Công ty) / ENTERPRISE (Tập Đoàn)
    "company_type": "COMPANY", // optional - Loại hình phân cấp: GROUP / CORPORATION / COMPANY
    "parent_company_id": undefined, // optional - Công ty cha
};

// validation form
model.validForm = {
    "name": // optional Tên công ty
    {
        "name_vi": [
                        ValidService.required,
                        ValidService.checkSpaceString,
                        ValidService.checkVietNameseHaveNumber
                    ], // required Tên công ty tiếng việt
        "name_en": [
                        ValidService.checkSpaceString,
                        ValidService.checkVietNameseHaveNumber
                    ], // optional Tên công ty tiếng anh
        "abbreviation_name": [
                                ValidService.required,
                                ValidService.checkSpaceString,
                                ValidService.check_Az09,
                                ValidService.checkLength1(3,5),
                            ], // required, minLength: 3, maxLength: 5 Tên viết tắt
    },
    "representative": // optional Người đại diện
    {
        "name": [
            ValidService.checkVietNameseNoNumber
        ], // optional Tên người đại diện
        "phone_number": [ValidService.checkNumber], // optional Điện thoại cố định
        "mobile_phone": [ValidService.checkNumber, ValidService.checkPhone], // required, pattern: //^0\d{9}$//Điện thoại
        "email": [ValidService.checkEmail], // required Email
        "address": // optional Địa chỉ người đại diện
        {
            "province_id": [], // optional Mã tỉnh/TP
            "province_name": [], // optional Tên tỉnh/TP
            "district_id": [], // optional Mã quận/huyện
            "district_name": [], // optional Tên quận/huyện
            "commune_id": [], // optional Mã xã
            "commune_name": [], // optional Tên xã
            "address": [
                        ValidService.checkSpaceString,
                        ValidService.checkMaxLength(5000)
                    ], // optional Địa chỉ đầy đủ
        },
        "identity_card": [ValidService.checkNumber], // optional Số CMT
        "identity_card_img_before_id": [], // optional Ảnh của CMT mặt trước
        "identity_card_img_after_id": [], // optional Ảnh của CMT mặt sau
    },
    "contact": // optional Người liên hệ
    {
        "name": [
            ValidService.checkVietNameseNoNumber
        ], // optional Tên người liên hệ
        "phone_number": [ValidService.checkNumber], // optional Điện thoại cố định
        "mobile_phone": [ValidService.required, ValidService.checkNumber, ValidService.checkPhone], // required, pattern: //^0\d{9}$// pattern: /^0\d{9}$/ Điện thoại
        "email": [ValidService.required, ValidService.checkEmail], // required Email
        "address": // optional Địa chỉ người đại diện
        {
            "province_id": [], // optional Mã tỉnh/TP
            "province_name": [], // optional Tên tỉnh/TP
            "district_id": [], // optional Mã quận/huyện
            "district_name": [], // optional Tên quận/huyện
            "commune_id": [], // optional Mã xã
            "commune_name": [], // optional Tên xã
            "address": [
                        ValidService.checkSpaceString,
                        ValidService.checkMaxLength(5000)
                    ], // optional Địa chỉ đầy đủ
        },
        "identity_card": [ValidService.checkNumber], // optional Số CMT
        "identity_card_img_before_id": [], // optional Ảnh của CMT mặt trước
        "identity_card_img_after_id": [], // optional Ảnh của CMT mặt sau
    },
    "address": // required Trụ sở chính
    {
        "province_id": [ValidService.requiredChange], // optional Mã tỉnh/TP
        "province_name": [], // optional Tên tỉnh/TP
        "district_id": [ValidService.requiredChange], // optional Mã quận/huyện
        "district_name": [], // optional Tên quận/huyện
        "commune_id": [ValidService.requiredChange], // optional Mã xã
        "commune_name": [], // optional Tên xã
        "address": [
                        ValidService.checkSpaceString,
                        ValidService.required,
                        ValidService.checkMaxLength(5000)
                    ], // optional Địa chỉ đầy đủ
    },
    "phone_number": // required Điện thoại công ty
    {
        "phone_number": [ValidService.required, ValidService.checkNumber], // optional Điện thoại cố định
        "mobile_phone": [ValidService.checkNumber, ValidService.checkPhone], // optional, pattern: //^0\d{9}$// Điện thoại di động
    },
    "fax": [ValidService.checkNumber], // optional - Số fax
    "business_registration": // optional - Đăng ký kinh doanh
    {
      "number": [ValidService.checkNumber, ValidService.checkMaxLength(10)], // optional - Số đăng ký kinh doanh
      "issue_date": [], // optional - Ngày cấp
      "issue_by": [], // optional - Nơi cấp
    },
    "tax_number": [ValidService.checkNumber, ValidService.checkMaxLength(10)], // optional - Mã số thuế
    "disabled": [], // required Đã bị khóa chưa
    "logo_id": [],
    "bank_account": // optional - Thông tin tài khoản công ty
    {
      "number": [ValidService.checkNumber, ValidService.checkMaxLength(15)], // optional - Số tài khoản
      "bank_name": undefined, // optional - Tên ngân hàng
      "bank_branch_name": undefined, // optional - Tên chi nhánh
    },
    "organization_type": [], // optional - Loại tổ chức
    "company_type": [ValidService.requiredChange], // optional - Loại hình phân cấp
    "parent_company_id": [], // optional - Công ty cha
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        MatTruocCMNDRepresentative: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        MatSauCMNDRepresentative: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        MatTruocCMNDContact: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
        },
        MatSauCMNDContact: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        Logo: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {};

model.listGender = [
  {
    value: 'FEMALE',
    label: "Nữ"
  },
  {
    value: 'MALE',
    label: "Nam"
  },
  {
    value: 'OTHER',
    label: "Khác"
  }
]

model.listOrganizationType = [
  {
    value: 'COMPANY',
    label: "Công ty"
  },
  {
    value: 'ENTERPRISE',
    label: "Tập Đoàn"
  }
]

model.listCompanyType = [
  {
    value: 'GROUP',
    label: "Tập đoàn"
  },
  {
    value: 'CORPORATION',
    label: "Tổng công ty"
  },
  {
    value: 'COMPANY',
    label: "Công ty con"
  }
]

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            'name.name_vi': '',
            'representative.name': '',
            "contact.name": '',
            "phone_number.mobile_phone": '',
            "phone_number.phone_number": '',
            "address.province_id": "",
            "address.district_id": "",
            "address.commune_id": "",
            "address.address": "",
            "disabled": "",
        },
        valid: {
            'name.name_vi': [],
            'representative.name': [],
            "contact.name": [],
            "phone_number.mobile_phone": [ValidService.checkNumber],
            "phone_number.phone_number": [ValidService.checkNumber],
            "address.province_id": [],
            "address.district_id": [],
            "address.commune_id": [],
            "address.address": [],
            "disabled": []
        },
        operator: {
            'name.name_vi': "$vn_text=",
            'representative.name': ":regex_i:",
            "contact.name": ":regex_i:",
            "phone_number.mobile_phone": ':regex_i:',
            "phone_number.phone_number": ':regex_i:',
            "address.province_id": '',
            "address.district_id": '',
            "address.commune_id": '',
            "address.address": ':regex_i:',
            "disabled": "",
        }
    }
};

export default model;
